// extracted by mini-css-extract-plugin
module.exports = {"layoutContainer":"TicketLanding_layoutContainer__ABIW_","qr":"TicketLanding_qr__5tKE3"};